module.exports = __webpack_public_path__ + "static/media/tiktok29.e29261ef.svg";